import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 75 15",
  "xml:space": "preserve",
  width: "75",
  height: "75"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M73.894-9.494v2.27l-.787.58v.97c0 1.204-2.016 1.437-2.016 1.437l-5.47 1.203C52.543-.821 48.865 6.465 48.865 10.493c0 1.981.983 3.735 2.498 4.79l5.089 1.595s.359.097.489.27l3.28 3.845c.452.53.295.963.295.963v4.752h-8.617s-1.588-.203-2.208-1.329c0 0-1.63-2.606-8.828-2.606h-.643c-7.197 0-8.827 2.606-8.827 2.606-.621 1.126-2.208 1.329-2.208 1.329H20.38v-4.752s-.064-.478.39-1.008l3.313-3.89c.13-.174.518-.363.518-.363l5.013-1.792h.012c1.375 0 2.308-2.027 2.308-3.704 0-3.061-2.725-5.493-5.787-5.493l-3.266-.014C7.43 5.536.426-6.033.426-6.033l-.057-.08a.58.58 0 0 1 .49-.906c.026 0 .053.025.08.027l.993.124c6.275.369 8.152.522 8.152.522h13.443V-7.92h1.305c2.253 0 2.63-.314 2.63-.314v-1.26Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }